module.exports = __webpack_public_path__ + "static/media/rss.ce3bf04d.png";